import { CaretRightIcon, CreditCardIcon, TicketIcon } from '@phosphor-icons/react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/business/visitor-parking/button'

import { useVisitorParkingAnalytics } from '../visitor-parking.hooks'
import * as S from './welcome-screen.styled'

interface WelcomeScreenProps {
  onNext: () => void
}

export const WelcomeScreen = ({ onNext }: WelcomeScreenProps) => {
  const { t } = useTranslation(['visitor-parking'])
  const { handleTrackFlowStarted } = useVisitorParkingAnalytics()

  useEffect(() => {
    handleTrackFlowStarted()
  }, [handleTrackFlowStarted])

  return (
    <S.Container>
      <S.PhotoContainer>
        <S.VisitorParkingTitle>{t('visitor-parking:welcomeScreen.title')}</S.VisitorParkingTitle>
        <S.Photo
          alt={t('visitor-parking:welcomeScreen.photoAlt')}
          src="/images/visitor-parking/car.png"
        />
      </S.PhotoContainer>

      <S.Content>
        <S.Heading>{t('visitor-parking:welcomeScreen.heading')}</S.Heading>
        <S.Description>{t('visitor-parking:welcomeScreen.description')}</S.Description>

        <S.FeatureList>
          <S.FeatureItem>
            <S.FeatureIcon icon={CreditCardIcon} size="2.4rem" />
            <S.FeatureText>{t('visitor-parking:welcomeScreen.featureQuickPayment')}</S.FeatureText>
          </S.FeatureItem>
          <S.FeatureSeparator />
          <S.FeatureItem>
            <S.FeatureIcon icon={TicketIcon} size="2.4rem" />
            <S.FeatureText>
              {t('visitor-parking:welcomeScreen.featureInstantConfirmation')}
            </S.FeatureText>
          </S.FeatureItem>
        </S.FeatureList>

        <S.SecurePayment>
          <S.SecurePaymentText>
            {t('visitor-parking:welcomeScreen.securePaymentText')}
          </S.SecurePaymentText>
          <S.StripeLogo
            alt={t('visitor-parking:welcomeScreen.stripeLogoAlt')}
            src="/images/visitor-parking/stripe-logo.png"
          />
        </S.SecurePayment>

        <Button onClick={onNext}>
          {t('visitor-parking:welcomeScreen.getStarted')}
          <S.ButtonIcon icon={CaretRightIcon} />
        </Button>
      </S.Content>
    </S.Container>
  )
}
